import { httpCall } from "@common/util";
import AppConstants from "@config/appConstants";
import { getAuthHeaders } from "@utils/authManager.js";

export const fetchWorkkardFields = ({ short_name, render_type = 'new' }) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: `/1.0/template/workkard/${short_name}/fields?render_type=${render_type}`,
  });
};

export const fetchCarriers = () => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: `/1.0/carriers`,
  });
};

export const createWorkkard = (payload) => {
  return httpCall({
    method: AppConstants.httpMethod.POST,
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    url: `/1.0/workkard/new`,
    data: payload,
  }, true);
};

export const fetchWorkkardById = (workkardId) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: `/1.0/workkard/${workkardId}`,
  });
};

export const updateWorkkard = (payload) => {
  return httpCall({
    method: AppConstants.httpMethod.PUT,
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    url: `/1.0/workkard/update/${payload.id}`,
    data: payload.data,
  }, true);
};
